import { useEffect } from 'react'

export const usePageView = (): void => {
  useEffect(() => undefined, [])
}
